import { useId } from 'react';

/**
 * CLM-89 (R-89-1) — open the signed document in SharePoint in a new tab. The API
 * hands out `clm.contract.sharepoint_item_url` (Graph's webUrl); the user's own
 * SharePoint session authenticates and its permissions apply (IR-05: referenced,
 * never copied). When intake recorded no link the control renders disabled with
 * the reason in its title, the way `.btn:disabled` reads elsewhere — and, for
 * keyboard and screen-reader users, the control is focusable and the same reason
 * is announced through `aria-describedby` from a visually-hidden sibling (D-89-3).
 */
const DISABLED_REASON = 'No SharePoint link is recorded for this contract';

export function OpenContractLink({
  url,
  compact = false,
}: {
  readonly url: string | null | undefined;
  /** Icon-sized for a table cell; the full label is kept for assistive tech. */
  readonly compact?: boolean;
}) {
  const reasonId = useId();
  const label = 'Open contract';
  const className = compact ? 'btn sm qt open-contract compact' : 'btn sm open-contract';
  if (typeof url === 'string') {
    return (
      <a
        className={className}
        href={url}
        target="_blank"
        rel="noreferrer"
        aria-label={`${label} in SharePoint (new tab)`}
      >
        {compact ? '↗' : label}
      </a>
    );
  }
  return (
    <>
      <span
        className={className}
        aria-disabled="true"
        aria-describedby={reasonId}
        tabIndex={0}
        title={DISABLED_REASON}
        data-testid="open-contract-disabled"
      >
        {compact ? '↗' : label}
      </span>
      <span id={reasonId} className="vh">
        {DISABLED_REASON}
      </span>
    </>
  );
}
